import Vue from "vue";
import Router, { NavigationGuard } from "vue-router";
import { RouterOptions } from "vue-router";
import Home from "../views/Home.vue";
import { getModule } from "vuex-module-decorators";
import { store, UserModule } from "@/store";
import UserModel, { UserRole } from "@/models/User";
import firebase from "firebase";
import { firebaseInitPromise } from "../plugins/firebaseinit";
import _debug from "debug";
import EventBus, { DeclaredEvents, SnackPriorityToColor } from "@/EventBus";

const debug = _debug("Mediacao:router.ts");

const userModule = getModule(UserModule, store);

Vue.use(Router);

const routes = [
    {
        path: "/",
        name: "home",
        component: Home,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/login",
        name: "login",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ "../views/Login.vue"),
    },
    {
        path: "/users",
        name: "users",
        component: () => import(/* webpackChunkName: "users" */ "../views/Users.vue"),
        meta: {
            requiresAuth: true,
            roles: ["admin"],
        },
    },
    {
        path: "/users/cadastro",
        name: "usuarioCadastro",
        component: () => import(/* webpackChunkName: "usuarioCadastro" */ "../views/UsuarioCadastro.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/processos",
        name: "processos",
        component: () => import(/* webpackChunkName: "about" */ "../views/processo/Processos.vue"),
        meta: {
            requiresAuth: true,
            roles: ["admin", "mediador"],
        },
    },
    {
        path: "/processos-todos",
        name: "processos-todos",
        component: () => import(/* webpackChunkName: "about" */ "../views/processo/ProcessosTodos.vue"),
        meta: {
            requiresAuth: true,
            roles: ["admin"],
        },
    },
    {
        path: "/processo/:id/:solicitacao?",
        name: "processo-cadastro",
        component: () => import(/* webpackChunkName: "about" */ "../views/processo/ProcessoCadastro.vue"),
        meta: {
            requiresAuth: true,
            roles: ["admin", "mediador", "parte"],
        },
    },
    {
        path: "/solicitacoes",
        name: "Solicitações",
        component: () => import(/* webpackChunkName: "about" */ "../views/Solicitacoes.vue"),
        meta: {
            requiresAuth: true,
            roles: ["admin", "mediador"],
        },
    },
    {
        path: "/solicitacao/:id",
        name: "solicitacaoCadastro",
        component: () => import(/* webpackChunkName: "solicitacaoCadastro" */ "../views/SolicitacaoCadastro.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/processo/:id/chat/:idChat",
        name: "processo-chat",
        component: () => import(/* webpackChunkName: "about" */ "../views/processo/ChatView.vue"),
        meta: {
            requiresAuth: true,
            roles: ["admin", "mediador", "parte"],
        },
    },
];

const router = new Router({
    routes,
});

router.beforeEach(async (to, from, next) => {
    debug("router.beforeEach", to, from, next);
    const currentUser = userModule.getUser;
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const requiredRoles = to.matched.reduce((previous, record) => {
        if (record.meta.roles) {
            return previous.concat(record.meta.roles);
        } else {
            return [];
        }
    }, [] as UserRole[]);

    debug("before, currentUser, requiresAuth, to.path", currentUser, requiresAuth, to.path, currentUser.isRealUser, requiredRoles);

    debug("esperando firebase ficar pronto...");
    const firebaseApp = await firebaseInitPromise;
    debug("firebase ficou pronto...", firebaseApp);

    let gotoRoute;

    if (to.path === "/logout") {
        firebase.auth().signOut();
        EventBus.$emit("logout");
    } else {
        if (requiresAuth) {
            if (!currentUser.isRealUser) {
                debug("Usuario tentando acessar rota protegida sem estar autenticado!");
                gotoRoute = "login";
            } else {
                if (requiredRoles.length > 0) {
                    if (!currentUser.hasRoleOf(requiredRoles)) {
                        gotoRoute = "/";
                        debug("Usuário não tem perfil para a rota!", to.path, requiredRoles);
                    }
                }
            }
            if (!gotoRoute && !currentUser.temCadastroPreenchido && to.path !== "/users/cadastro") {
                gotoRoute = {
                    path: "/users/cadastro",
                    query: {
                        modo: "proprio",
                    },
                };
            }
        } else if (!requiresAuth && currentUser.isRealUser) {
            debug("Não requer autenticacao, mas já está autenticado!");
            // gotoRoute = "/";
        }
    }
    debug(`router.gotoRoute=${gotoRoute}, to.path=${to.path}`);
    if (gotoRoute && !(to.path === gotoRoute)) {
        debug("Mudando a rota");
        next(gotoRoute);
    } else {
        debug("Seguindo com a rota");
        next();
    }
});

export default router;
